












        import Vue from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';

    export default Vue.extend({
        name: 'tooltip-button',
        props: {
            ariaLabel: { type: String, required: true },
            tooltip: { type: String, required: true },
            icon: { type: String, required: true },
            outlined: { type: Boolean, required: false },
            disabled: { type: Boolean, required: false }
        },
        methods: {
            clickHandler() {
                this.$emit('click');
            }
        },
        computed: {
        }

    });
